
import Vue from "vue"

export default Vue.extend({
  props: {
    name: { type: String, default: "" },
    role: { type: String, default: "" },
    photoUrl: { type: String, default: "" },
  },
})
